<template>
  <div id="ticketing-step-1" v-if="step === 2">
    <div class="ticketing-content">
      <div class="card">
        <div class="table-responsive">
          <table class="table table-nowrap card-table">
            <thead>
              <tr>
                <th>Combo</th>
                <th class="text-right">Giá tiền</th>
                <th class="text-right">Số lượng</th>
              </tr>
            </thead>
            <tbody>
              <tr class="ticketing-cart-item" v-for="concession in concessions" :key="concession.id">
                <td class="ticketing-cart-item-name">
                  {{ concession.name }}
                  <span class="text-muted d-block"
                        v-if="concession.description !== concession.name">{{ concession.description }}</span>
                </td>
                <td class="ticketing-cart-item-price text-right">
                  <span :class="concession.discount > 0 ? 'text-danger' : ''">
                    {{ useFormatting().formatCurrency(concession.price) }}
                  </span>
                  <span v-if="concession.discount > 0" class="d-block">
                    <span class="badge badge-danger">
                    -{{ useFormatting().formatCurrency(concession.discount) }}
                  </span>
                  </span>
                </td>
                <td class="ticketing-cart-item-quantity text-right">
                  <div class="quantity-toggle">
                    <a class="btn btn-sm btn-rounded-circle btn-white"
                       :class="{ 'disabled': concession.quantity === 0 }"
                       @click="updateConcession(concession, 'remove')">-</a>
                    <input type="text" min="0" max="10"
                           class="form-control form-control-flush text-dark text-center d-inline"
                           :value="concession.quantity" style="width: 30px;" readonly>
                    <a class="btn btn-sm btn-rounded-circle btn-white"
                       :class="{ 'disabled': concession.quantity === 10 }"
                       @click="updateConcession(concession, 'add')">+</a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useFormatting } from '../composables/formatting';
import debounce from 'lodash.debounce';

const props = defineProps({
  step: {
    type: Number,
    required: true
  },
  concessions: {
    type: Array,
    required: true
  },
})

const emit = defineEmits([
  'update:concession'
])

const updateConcession = debounce((concession, action) => {
  emit('update:concession', { concession, action })
}, 100) // 100ms debounce
</script> 